import {Spine} from "pixi-spine";
import { Spine as Spine4, Skin } from "@pixi-spine/runtime-4.1";
import { Graphics, Texture, SCALE_MODES, DisplayObject, RenderTexture } from "pixi.js";
import { IServiceProvider } from "@westpierstudio/luma/services";

//Handles negative values
export function mod(a: number, b: number): number {
    return ((a%b)+b)%b;
}

export function devLog(msg: string): void {

    if (process.env.NODE_ENV !== `production`) {
        console.log(msg);
    }
}

export function toRad(angle: number): number {
    return angle * (Math.PI / 180);
}

export function toDeg(angle: number): number {
    return angle * (180 / Math.PI);
}

export function copyToClipboard(str: string): void {

    const textArea = document.createElement(`textarea`);
    textArea.value = str;
    textArea.setAttribute(`readonly`, ``);
    textArea.style.position = `absolute`;
    textArea.style.left = `-9999px`;
    document.body.appendChild(textArea);

    const selection = (document as Document).getSelection() as Selection;

    const selected = selection.rangeCount > 0 ? selection.getRangeAt(0) : false;

    textArea.select();
    document.execCommand(`copy`);
    document.body.removeChild(textArea);

    if (selected) {

        selection.removeAllRanges();
        selection.addRange(selected);
    }
}

export function saveFile(text: string, filename: string): void {
    const element = document.createElement(`a`);
    element.setAttribute(`href`, `data:text/plain;charset=utf-8,` + encodeURIComponent(text));
    element.setAttribute(`download`, filename);
    element.style.display = `none`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}

export async function loadFile() {
    return new Promise<any>((resolve, reject) => {
        const element = document.createElement(`input`);
        element.setAttribute(`type`, `file`);
        element.setAttribute(`accept`, `.json`);
        element.addEventListener(`change`, (event) => {
            if (!event.target) {
                return;
            }
            // @ts-ignore
            const fileList = event.target.files;

            const reader = new FileReader();
            reader.addEventListener(`load`, (event) => {
                const text = event.target?.result;
                if (!text) {
                    return;
                }
                const data = JSON.parse(text.toString());
                resolve(data);
            });
            reader.readAsText(fileList[0]);
        });
        element.click();
    });
}

function drawRect(width: number, height: number, colour: number, alpha=1.0): Graphics {

    const graphic = new Graphics();

    graphic.beginFill(colour, alpha);
    graphic.drawRect(0, 0, width, height);
    graphic.endFill();

    return graphic;
}

export function getRectTexture(services: IServiceProvider, width: number, height: number, colour: number, resolution: number, alpha?: number): Texture {
    const graphics = drawRect(width, height, colour, alpha);
    const texture = graphicsToTexture(services, graphics, resolution);
    graphics.destroy({children: true, texture: true, baseTexture: true});
    return texture;
}

function graphicsToTexture(services: IServiceProvider, graphics: Graphics, resolution: number) {
    const renderTexture = RenderTexture.create({
        width: graphics.width,
        height: graphics.height,
        scaleMode: SCALE_MODES.LINEAR,
        resolution
    });
    services.application.renderer.render(graphics, {renderTexture});
    return renderTexture;
}

export function setSpineSkins(spine: Spine, skinNames: string[]): void {

    const combined = new Skin(`combined`);
    const spine4 = (spine as Spine4);

    skinNames.forEach(name => combined.addSkin(spine4.skeleton.data.findSkin(name)));

    spine4.skeleton.setSkin(combined);
    spine4.skeleton.setToSetupPose();
}

export function addToSpineSlot(spine: Spine, displayObject: DisplayObject, slotName: string) {

    const slotIndex = spine.skeleton.findSlotIndex(slotName);

    if (slotIndex >= 0) {
        (spine as any).children[slotIndex].addChild(displayObject);

    } else {
        throw new Error(`addToSpineSlot - Slot not found: ` + slotName);
    }
}

export function resetSpine(spine: Spine): void {

    spine.state.clearTracks();
    spine.state.clearListeners();
    spine.skeleton.setToSetupPose();
}